import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../hooks/useSession.ts';

interface UpgradeButtonProps {
  label?: string;
  className?: string;
  plan?: 'oneoff' | 'pro';
}

// Reusable button that navigates user to upgrade flow, requiring authentication
const UpgradeButton: React.FC<UpgradeButtonProps> = ({ label = 'Upgrade to Pro', className = '', plan = 'pro' }) => {
  const navigate = useNavigate();
  const { session } = useSession();

  const handleClick = () => {
    if (!session?.access_token) {
      navigate('/signup?redirect=/upgrade');
    } else {
      if (plan === 'pro') {
        navigate('/upgrade');
      } else {
        // For one-off plan we still navigate to upgrade where user can choose
        navigate('/upgrade');
      }
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={className}
    >
      {label}
    </button>
  );
};

export default UpgradeButton; 